// extracted by mini-css-extract-plugin
export default {"formFooter":"formFooter_formFooter__1aenm","divider":"formFooter_divider__A66dZ","actions":"formFooter_actions__h8HbT","list":"formFooter_list__gJ0DL"};